import { render, staticRenderFns } from "./quest-tracking-data-item-normal.vue?vue&type=template&id=1dcd2bd6&scoped=true"
import script from "./quest-tracking-data-item-normal.vue?vue&type=script&lang=js"
export * from "./quest-tracking-data-item-normal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dcd2bd6",
  null
  
)

export default component.exports